export default __webpack_public_path__ + "static/media/bg-view.20addc05.png";